import styles from "./styles/mastering-options-header.module.scss";
import { useAiMastering } from "@/components/pages/ai-mastering/providers/ai-mastering-provider";

const MasteringOptionsHeader = () => {
  const { setCurrentOptionTab, currentOptionTab } = useAiMastering();

  return (
    <div className={styles.mastering_options_header}>
      <p
        onClick={() => setCurrentOptionTab("preset")}
        className={currentOptionTab === "preset" ? styles.selected_tab : ""}
      >
        Presets
      </p>
      <p
        onClick={() => setCurrentOptionTab("referenceTrack")}
        className={
          currentOptionTab === "referenceTrack" ? styles.selected_tab : ""
        }
      >
        Reference Track
      </p>
    </div>
  );
};

export default MasteringOptionsHeader;
